import { Box } from '@mui/material'
import { MISC_CYAN } from '../theme/onboardingTheme'

export function WavePattern() {
  return (
    <Box
      aria-hidden
      sx={{
        pointerEvents: 'none',
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
        opacity: 0.4,
      }}
    >
      <Box
        component="svg"
        preserveAspectRatio="none"
        sx={{
          position: 'absolute',
          left: '-25%',
          top: 0,
          height: '100%',
          width: '150%',
          color: 'rgba(34, 211, 238, 0.3)',
        }}
      >
        <defs>
          <pattern
            id="misc-waves"
            width="80"
            height="80"
            patternUnits="userSpaceOnUse"
            patternTransform="rotate(-12)"
          >
            <path
              d="M0 40 Q20 20 40 40 T80 40"
              fill="none"
              stroke="currentColor"
              strokeWidth="0.5"
            />
            <path
              d="M0 60 Q20 40 40 60 T80 60"
              fill="none"
              stroke="currentColor"
              strokeWidth="0.5"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#misc-waves)" />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: `linear-gradient(to bottom right, ${MISC_CYAN}0D, transparent, rgba(37, 99, 235, 0.10))`,
        }}
      />
    </Box>
  )
}
